// 商品一覧のバリエーション画像の切り替え
window.setupImageSwitcher = function() {
  
  // #ProductGridContainerまたは.card__variant_chipsが存在するか確認
  if (!document.querySelector('#ProductGridContainer') && !document.querySelector('.card__variant_chips')) return;
  const parentElement = document.querySelector('#ProductGridContainer') || document.querySelector('#MainContent');

  if (parentElement) {
      parentElement.addEventListener('click', function(event) {
          const clickedElement = event.target;

          // クリックされた要素が期待するimgタグであるか確認
          if (clickedElement.tagName === 'IMG' && clickedElement.closest('.card__variant_chips')) {
              const closestCard = clickedElement.closest('.grid__item') || clickedElement.closest('.swiper-slide');
              if (!closestCard) return;

              const mainImage = closestCard.querySelector('.card_media_image ');
              if (mainImage) {
                  mainImage.src = clickedElement.dataset.productimage;
                  mainImage.srcset = clickedElement.dataset.productimage;
              }

              const secondaryImage = closestCard.querySelector('.card_media_image2');
              if (secondaryImage) {
                  secondaryImage.src = clickedElement.dataset.productimage;
                  secondaryImage.srcset = clickedElement.dataset.productimage;
              }

              const allThumbs = closestCard.querySelectorAll('.card__variant_chips img');
              allThumbs.forEach(thumb => thumb.classList.remove('current'));
              clickedElement.classList.add('current');
          }
      });
  }
}
setupImageSwitcher();

// FAQ
var dtElements = document.querySelectorAll('.faqWrap dt');
dtElements.forEach(function(element) {
  element.addEventListener('click', function(event) {
      event.target.classList.toggle('open');
  });
});

// ヘッダースティッキー
if(document.querySelector('.sticky-header_all') != null){
	const sticky_header_all = document.querySelector('.sticky-header_all');
	const sticky_padding = document.querySelector('.sticky_padding');
	let sticky_header_allTop = sticky_header_all.getBoundingClientRect();
	let sticky_header_allTop_position = sticky_header_allTop.top + window.pageYOffset;
	let sticky_header_all_height = sticky_header_all.clientHeight;
	let sticky_header_Animation = function() {
		let header_scroll_position = window.pageYOffset;
		if(header_scroll_position > sticky_header_allTop_position){
  		sticky_header_all.classList.add('sticky_on');
		sticky_padding.style.paddingTop = sticky_header_all_height + "px";
        sticky_padding.classList.add('sticky_on');
 		}  else {
  	sticky_header_all.classList.remove('sticky_on');
		sticky_padding.style.paddingTop = "0";
        sticky_padding.classList.remove('sticky_on');
 	}
	}
	window.addEventListener('scroll', sticky_header_Animation);
}


// フッターTOPに戻る
if(document.getElementById("side_to_top_btn_sec") != null){
	const pageTop =  document.getElementById('side_to_top_btn_sec');
	const pageTopBtn1 =  document.getElementById('side_to_top_btn');
	let Animation = function() {
	//アイコン位置取得

	//要素の位置座標を取得
	let rect = pageTop.getBoundingClientRect();
	//topからの距離
	let scrollTop = rect.top + window.pageYOffset;

	if(scrollTop > 600){
		pageTop.classList.add('show');
		}  else {
		pageTop.classList.remove('show');
		}
	}
	window.addEventListener('scroll', Animation);
	pageTopBtn1.addEventListener("click", scroll_top);
}


// フッターTOPに戻る
if(document.getElementById("footer_to_top_btn") != null){
	const pagetopBtn = document.querySelector('#footer_to_top_btn');
	pagetopBtn.addEventListener("click", scroll_top);
};

function scroll_top() {
	window.scrollTo(0, 0);
}
  


// 別ホストのリンクを_blankで開く
window.addEventListener('DOMContentLoaded', function() {
  const links = document.links;
  const linksLength = links.length;
  for (let i = 0; i < linksLength ; i++) {
	if (links[i].hostname !== window.location.hostname) {
	  links[i].target = '_blank';
	  links[i].rel = 'noreferrer noopener';
	}
  }
});

// multiGridマウススクロール

jQuery.prototype.mousedragscrollable = function () {
  let target;
  $(this).each(function (i, e) {
    $(e).on("mousedown", function (event) {
      event.preventDefault();
      target = $(e);
      $(e).data({
        down: true,
        move: false,
        x: event.clientX,
        y: event.clientY,
        scrollleft: $(e).scrollLeft(),
        scrolltop: $(e).scrollTop(),
      });
      return false;
    });

    $(e).on("mousemove", function (event) {
      if ($(e).data("down")) {
        event.preventDefault();
        let move_x = $(e).data("x") - event.clientX;
        let move_y = $(e).data("y") - event.clientY;
        if (move_x !== 0 || move_y !== 0) {
          $(e).data("move", true);
        } else {
          return;
        }
        $(e).scrollLeft($(e).data("scrollleft") + move_x);
        $(e).scrollTop($(e).data("scrolltop") + move_y);
        return false;
      }
    });

    $(e).on("mouseup", function (event) {
      if ($(e).data("down")) {
        $(e).data("down", false);
        return false;
      }
    });

    $(e).click(function (event) {
      if ($(e).data("move")) {
        return false;
      }
    });
  });
};


  $(".multiGrid").mousedragscrollable();


	//商品詳細ページのタブ切り替え
  $(function(){ 
		//$('.descriptionTab')が存在する場合に下記を実行
		if($('.descriptionTab').length){
			//$('.descriptionTab .tabContent--A')が存在する場合、1番目のtab_containerの中身に移動させる
			if($('.descriptionTab .tabContent--A').length){
				$('.descriptionTab .tabContent--A').appendTo($('.descriptionTab .tab__container.--A'));
			}
			//$('.descriptionTab .tabContent--B')が存在する場合、2番目のtab_containerの中身に移動させる
			if($('.descriptionTab .tabContent--B').length){
				$('.descriptionTab .tabContent--B').appendTo($('.descriptionTab .tab__container.--B'));
			}
		}
		
    $('.descriptionTab .tab__head span').click(function () { // クリックイベントを設定する
      $(this).addClass('is-active'); // クリックされたタブをアクティブにする
      $(this).siblings().removeClass('is-active'); // 兄弟要素のアクティブを解除する
      $(this).closest('.tab__head').next('.tab__containerWrap').children('.tab__container').eq($(this).index()).addClass('is-active'); // クリックされたタブに対応するコンテンツを表示する
      $(this).closest('.tab__head').next('.tab__containerWrap').children('.tab__container').not(':eq(' + $(this).index() + ')').removeClass('is-active'); // クリックされたタブ以外のコンテンツを非表示にする
    });
  });


//サイドメニュー
//アコーディオンボタン
$(function(){
	$('.accordionButton').click(function(){
		if ($(this).attr('aria-expanded') == 'false') {
			$(this).attr('aria-expanded', true);
			$(this).next().slideDown();
		} else {
				$(this).attr('aria-expanded', false);
				$(this).next().slideUp();
		}
	});
});

////header-typeE
// ナビゲーション 子要素展開
$(function() {
	var ua = navigator.userAgent;
	// タブレット・スマートフォン時
	if ((ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0) && ua.indexOf('Mobile') > 0||ua.indexOf('iPad') > 0) {
		$('.hasChildren > a').on('mouseenter touchstart', function(){
			$(this).toggleClass('open');
			$(this).next('ul,.megaMenu').toggleClass('open');
			return false;
		}).on('mouseleave touchend', function(){
					return false;
		});
		$('.hasChildren .hasChildren--close > a').on('mouseenter touchstart', function(){
			$(this).parents('ul').removeClass('open').prev('a').removeClass('open');
			return false;
		});

	}else{
	// PC時
		$('.hasChildren').hover(function() {
			$(this).children('a').addClass('open');
			$(this).children('ul,.megaMenu').addClass('open');
		}, function() {
			$(this).children('a').removeClass('open');
			$(this).children('ul,.megaMenu').removeClass('open');
		});
	}
});

// 検索ランキングキーワード
$(function() {
  // テキストボックスにフォーカス時、フォームの背景色を変化
  $('.search-header__form input[type="product"]')
    .focusin(function(e) {
      $(this).parents().next('.keywordRanking__toggle').addClass('open');
    })
    .focusout(function(e) {
      setTimeout(function(){
        $('.keywordRanking__toggle.open').removeClass('open');
      },200);
    });
});

//user-guide用
$(document).on("click", ".hasChildren--clickSP > h2", function () {
  var windowWidth = $(window).width();
  if (windowWidth < 1001) {
    var next = $(this).next();
    if ($(this).hasClass("open")) {
      $(this).removeClass("open");
      next.removeClass("open");
      next.slideUp();
    } else {
      const all = $(this)
        .parents("li")
        .parents()
        .parents(".gNav")
        .find(".hasChilds > span");
      all.removeClass("open");
      all.next().removeClass("open").slideUp(0);
      $(this).addClass("open");
      next.addClass("open").slideDown();
    }
    return false;
  }
});

// ==========================================
// 追従ヘッダー対応 アンカーリンク制御（チラつき完全封殺版）
// ==========================================
(function() {
  // PC（1001px以上）とSP（1000px以下）のヘッダー高さを定義
  const HEADER_PC = 146;
  const HEADER_SP = 56;
  const BREAK_POINT = 1001;

  // 現在の画面幅からヘッダーの「正しい高さ」を返す関数
  function getHeaderHeight() {
    return window.innerWidth >= BREAK_POINT ? HEADER_PC : HEADER_SP;
  }

  // 位置調整を実行する共通アニメーション関数
  function scrollToTarget(hash, isSmooth) {
    if (!hash) return;
    const target = document.querySelector(hash);
    if (target) {
      const targetTop = target.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = targetTop - getHeaderHeight();

      window.scrollTo({
        top: offsetPosition,
        behavior: isSmooth ? 'smooth' : 'auto'
      });
    }
  }

  // ------------------------------------------
  // ① 他ページからの URL#hash 流入時のチラつき・ズレ完全防止処理
  // ------------------------------------------
  if (window.location.hash) {
    const originalHash = window.location.hash;

    // ★【重要】ブラウザがハッシュを見つけてジャンプする前に、URLのハッシュを一時的に書き換えてジャンプを無効化する
    if (history.replaceState) {
      // URLの見栄えを一時的にハッシュなし（またはダミー）にして、ブラウザの自動スクロールを騙す
      history.replaceState(null, null, window.location.pathname + window.location.search);
    } else {
      // 古いブラウザ用（最悪トップに固定）
      window.scrollTo(0, 0);
    }

    // タイミングA: HTMLの組み立てが終わった瞬間（1回目の一発ワープ）
    window.addEventListener('DOMContentLoaded', function() {
      scrollToTarget(originalHash, false);
    });

    // タイミングB: すべての画像やShopifyアプリが読み込まれ、高さが完全に確定した瞬間（最終確定）
    window.addEventListener('load', function() {
      setTimeout(function() {
        // 正しい位置にワープさせる
        scrollToTarget(originalHash, false);
        
        // 最後にURLの表示だけ、本来のハッシュ（#section3など）に綺麗に戻す
        if (history.replaceState) {
          history.replaceState(null, null, window.location.pathname + window.location.search + originalHash);
        }
      }, 50); // ここの数値を微調整（20〜100）することで、サイトの重さに完全に合わせられます
    });
  }

  // ------------------------------------------
  // ② 同じページ内でのアンカーリンククリック時の処理
  // ------------------------------------------
  window.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', function(e) {
      const anchor = e.target.closest('a');
      if (!anchor) return;

      const targetHash = anchor.hash;
      if (targetHash) {
        const currentUrl = window.location.href.split('#')[0];
        const targetUrl = anchor.href.split('#')[0];

        if (currentUrl === targetUrl) {
          e.preventDefault();
          scrollToTarget(targetHash, true); // スムーススクロール

          if (history.pushState) {
            history.pushState(null, null, targetHash);
          } else {
            window.location.hash = targetHash;
          }
        }
      }
    });
  });
})();



// ==========================================
// セクション全自動スクロールアニメーション JS（最終決定版）
// ==========================================
(function() {
  function initScrollAnimation() {
    // ------------------------------------------
    // 【調整ポイント】アニメーションの各種ディレイ設定（ミリ秒）
    // ------------------------------------------
    const ANIMATION_DELAY = 450;      // 画面に入ってから発動するまでの基本待ち時間（0.45秒）
    const PRODUCT_STEP_DELAY = 350;   // 商品詳細用：画像 → 情報 → 説明文 の時間差（0.35秒）
    const GRID_STAGGER_DELAY = 150;   // 商品一覧用：カード（li）が横にパラパラ出る時間差（0.15秒）

    // すべてのターゲットを一括で指定（セクション、商品詳細エリア、関連商品、商品一覧のli）
    const targetSelector = '[class^="sec_"], [class*=" sec_"], .product-recommendations--loaded, .product__media-wrapper, .product__info-wrapper, .product__exp-wrapper, #product-grid .grid__item';

    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -10% 0px', // 下から10%の位置で判定
      threshold: 0
    };

    const observer = new IntersectionObserver(function(entries, observer) {
      // 同時に画面内に入ってきた要素だけを絞り込む（グリッドの時間差計算を正確にするため）
      const intersectingEntries = entries.filter(entry => entry.isIntersecting && entry.target.offsetHeight > 0);

      intersectingEntries.forEach(function(entry, index) {
        const targetEl = entry.target;

        // ① 【商品一覧】商品一覧グリッド（li）のパラパラ時差処理
        if (targetEl.closest('#product-grid')) {
          setTimeout(function() {
            targetEl.classList.add('animated');
          }, ANIMATION_DELAY + (index * GRID_STAGGER_DELAY));

        // ② 【商品詳細：1】左側の画像エリア
        } else if (targetEl.classList.contains('product__media-wrapper')) {
          setTimeout(function() { 
            targetEl.classList.add('animated'); 
          }, ANIMATION_DELAY);

        // ③ 【商品詳細：2】右側の情報エリア（基本 + 1ステップ遅延）
        } else if (targetEl.classList.contains('product__info-wrapper')) {
          setTimeout(function() { 
            targetEl.classList.add('animated'); 
          }, ANIMATION_DELAY + PRODUCT_STEP_DELAY);

        // ④ 【商品詳細：3】下部の商品説明エリア（基本 + 2ステップ遅延）
        } else if (targetEl.classList.contains('product__exp-wrapper')) {
          setTimeout(function() { 
            targetEl.classList.add('animated'); 
          }, ANIMATION_DELAY + (PRODUCT_STEP_DELAY * 2));

        // ⑤ 【通常セクション ＆ 関連商品の中身】一律ディレイ
        } else {
          setTimeout(function() {
            targetEl.classList.add('animated');
          }, ANIMATION_DELAY);
        }

        // 処理が終わったらこの要素の監視を終了
        observer.unobserve(targetEl);
      });
    }, observerOptions);

    // 既存の要素を監視登録
    const elements = document.querySelectorAll(targetSelector);
    elements.forEach(function(el) {
      observer.observe(el);
    });

    // ★ 後から遅れて生成される「関連商品」のロード完了を検知する監視（MutationObserver）
    const mutationObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const recommendations = document.querySelector('.product-recommendations--loaded');
          if (recommendations && !recommendations.classList.contains('is-observed')) {
            recommendations.classList.add('is-observed');
            observer.observe(recommendations);
            
            // 関連商品を無事キャッチできたら、このHTML構造監視は終了
            mutationObserver.disconnect();
          }
        }
      });
    });

    // ページ全体のクラス変化を常に見張る
    mutationObserver.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['class']
    });
  }

  // Shopifyの読み込みタイミングに合わせて確実に着火
  if (document.readyState === 'complete') {
    initScrollAnimation();
  } else {
    window.addEventListener('load', initScrollAnimation);
  }
})();